import { create } from 'zustand'

import type { AgentAnnotationArtifact } from 'features/ask-yogi/types'

export type AnnotationHighlight = {
  feature: string
  annotation: AgentAnnotationArtifact
}

export const HIDE_DELAY_MS = 200

type AnnotationHighlightState = {
  highlight: AnnotationHighlight | null
  hideTimer: ReturnType<typeof setTimeout> | null
  setHighlight: (next: AnnotationHighlight | null) => void
  cancelHide: () => void
  scheduleHide: () => void
  clearHighlight: () => void
}

export const useAnnotationHighlightStore = create<AnnotationHighlightState>()(
  (set, get) => ({
    highlight: null,
    hideTimer: null,
    setHighlight: (next) => {
      const { hideTimer } = get()
      if (hideTimer !== null) clearTimeout(hideTimer)
      set({ highlight: next, hideTimer: null })
    },
    cancelHide: () => {
      const { hideTimer } = get()
      if (hideTimer !== null) clearTimeout(hideTimer)
      set({ hideTimer: null })
    },
    scheduleHide: () => {
      const { hideTimer } = get()
      if (hideTimer !== null) clearTimeout(hideTimer)
      const timer = setTimeout(
        () => set({ highlight: null, hideTimer: null }),
        HIDE_DELAY_MS,
      )
      set({ hideTimer: timer })
    },
    // Navigating away never fires the mouseleave that would schedule a hide.
    clearHighlight: () => get().setHighlight(null),
  }),
)
